import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "announcement_container" }
const _hoisted_2 = { class: "icon_wrapper" }
const _hoisted_3 = { class: "icon_text" }
const _hoisted_4 = { class: "content_text" }

import { useThemeColor, useThemeColorWithAlpha } from '@/utils/theme'
import { Swiper, SwiperSlide } from 'swiper/vue'
import { Swiper as SwiperType, Autoplay } from 'swiper'
import { LmsDecorateModule } from '@/api/Models/HomeConfig'
import { computed, onDeactivated, onActivated, ref } from 'vue'
import { useRouter } from 'vue-router'
import { handleExternalUrl } from '@/utils/navigation'

interface TItem {
  appJumpStatus: number
  appJumpUrl: string
  appJumpCourseType: number
}

export default /*@__PURE__*/_defineComponent({
  __name: 'Announcement',
  props: {
    data: {}
  },
  setup(__props: any) {

_useCssVars(_ctx => ({
  "v1d91c89e": (_unref(themeColorWithAlpha)),
  "v97d3ff72": (_unref(themeColor))
}))

const props = __props

const swiperInstance = ref()
const setSwiper = (swiper: SwiperType) => {
  swiperInstance.value = swiper
}
onDeactivated(() => {
  swiperInstance.value.autoplay.pause()
})
onActivated(() => {
  swiperInstance.value.autoplay.start()
})

const router = useRouter()
const skipHandle = (item: TItem) => {
  switch (item.appJumpStatus) { // 链接
    case 1:
      handleExternalUrl({ jumpUrl: item.appJumpUrl })
      break
    case 2:
      router.push({ // 课程
        name: 'courseDetail',
        query: {
          id: item.appJumpUrl,
          courseId: '',
          endingType: 0,
          channel: 1,
          courseType: item.appJumpCourseType === 0 ? 'course' : 'courseWare'
        }
      })
      break
    case 3: // 资讯
      router.push('/broadcastDetail/' + item.appJumpUrl)
      break
    case 4: // 培训
      router.push('/trainingDetail?id=' + item.appJumpUrl)
      break
    case 5: // 考试
      router.push('/examInfo?examId=' + item.appJumpUrl)
      break
    case 6: // 调查
      router.push('/surveyInfo?investigationId=' + item.appJumpUrl)
      break
    default:
      break
  }
}

const announcementData = computed(() => {
  try {
    // console.log(JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json))
    return JSON.parse(props.data.lmsDecorateModuleCategories[0].datas[0].json)
  } catch (error) {
    return []
  }
})

const modules = [Autoplay]

const themeColor = useThemeColor()
const themeColorWithAlpha = useThemeColorWithAlpha(0.1)

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "iconfont icon-icon_shouye_gonggao" }, null, -1)),
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('app_home_notice')), 1)
    ]),
    _createVNode(_unref(Swiper), {
      modules: modules,
      "slides-per-view": 1,
      loop: "",
      autoplay: {
        disableOnInteraction: false
      },
      direction: "vertical",
      class: "content_warpper swiper-no-swiping",
      onSwiper: setSwiper
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(announcementData.value, (item, index) => {
          return (_openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index,
            class: "content_slide",
            onClick: ($event: any) => (skipHandle(item))
          }, {
            default: _withCtx(() => [
              _createElementVNode("p", _hoisted_4, _toDisplayString(item.remark), 1)
            ]),
            _: 2
          }, 1032, ["onClick"]))
        }), 128))
      ]),
      _: 1
    }),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "more_icon" }, [
      _createElementVNode("i", { class: "iconfont icon-icon_shouye_tiaozhuan" })
    ], -1))
  ], 512)), [
    [_vShow, announcementData.value && announcementData.value.length > 0]
  ])
}
}

})